module.exports = __webpack_public_path__ + "static/media/eye.919703cb.svg";